var React = require('react');

function ContentQrCode (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"content-qr-code"),React.createElement("g",{"key":1},React.createElement("g",null,[React.createElement("rect",{"x":"62.77","y":"62.97","width":"5.81","height":"5.81","key":0}),React.createElement("path",{"d":"M0,75.58h75.5V.07h-.05V0H59.15V.07H16.34V0H0V16.34H0V59.13H0V75.48H0ZM38,4.34H59.15v12H71.27v10H49.12V15.24H38Zm-33.67,12h12v-12H26.72v11H37.85V37.51H26.63V26.45H4.31Zm0,21.38H15.37V48.78H60.08V37.64H71.27V48.78H49V60H37.8V48.78H26.53v22.5H60V60.05H71.27V71.3H16.34V59.13h-12Z","key":1})]))]);
}

ContentQrCode.defaultProps = {"role":"presentation","viewBox":"0 0 75.54 75.58"};

module.exports = ContentQrCode;

ContentQrCode.default = ContentQrCode;
